export default __webpack_public_path__ + "151d69351ea499d936435a41e220f81e.png";